import { Layers } from "appworks/graphics/layers/layers";
import { TotalStakeStepperControl } from "appworks/ui/controls/standard/stepper/total-stake-stepper-control";
import { ControlFactory } from "appworks/ui/factories/control-factory";

export class EpicPortraitTotalStakeStepperControlFactory implements ControlFactory {
    public filter(layer: Layers) {
        if (layer.getFlexiButton("portrait_stake_up") &&
            layer.getFlexiButton("portrait_stake_down")) {
            return true;
        }

        return false;
    }

    public build(layer: Layers) {
        return [new TotalStakeStepperControl(layer.getFlexiButton("portrait_stake_down"), layer.getFlexiButton("portrait_stake_up"), layer.getFlexiText("stake_value"))];
    }
}
